module.exports = __webpack_public_path__ + "img/still (12).f6be5923.jpg";